<template>
  <div class="comment-praise-info">
    <div v-if="info.state" class="grade-info">
      <div class="grade-name">
        <Icon type="ios-easel" color="#f48b16e8" size="22" /> &#160 {{ info.grade }}
      </div>
      <!-- <div class="time-week"> {{ info.timeWeek }} </div> -->
      <div class="time-start-end">
        <div class="time-start">
          <Icon type="ios-time" color="#f48b16e8" size="22" /> &#160 {{ info.timeStart }}
        </div>
        <div class="boundary">
          <div class="boundary-line"></div>
        </div>
        <div class="time-end"> {{ info.timeEnd }} </div>
        <!-- <div class="time-diff"> {{ info.timeDiff }} </div> -->
      </div>

    </div>
    <div v-if="student[0].length || student[1].length" class="comment-conent">
      <div class="select-box">
        <div v-for="(item, index) in ['已评价', '未评价']" :key="index" class="select-btn"
          :class="{ activeLine: index === currIndex }" @click="currIndex = index">
          {{ item }}({{ student[index].length }})
        </div>
      </div>
      <div v-for="(item, index) in student" :key="index" class="comment-list-box"
        :class="{ hidde: index !== currIndex }">
        <div v-for="(item_min, indexn) in item" :key="indexn" class="student-item" @click="goView(
      index ? '/grade/commentIng' : '/grade/commentInfo',
      { lessonId: info.lessonId, teacherId: info.teacherId, id: item_min.Id }
    )">
          <div class="student-img">
            <img src="@assets/images/1.jpg" alt="" />
          </div>
          <div class="student-name"> {{ item_min.name }} <div class="arrive">到课</div>
          </div>
          <div class="go-commenting"> {{ index ? '去评论' : '' }} 〉 </div>
        </div>
        <div v-if="item.length" class="foot-text">已经全部加载完毕</div>
        <div v-else class="foot-text">没有数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { leaveamessageinquireall } from "@api/grade"
import { addZoo } from '@common'

export default {
  name: 'CommentPraiseInfo',
  data() {
    return {
      info: {},
      student: [[], []],
      currIndex: 1,
      weekSelect: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
    }
  },
  methods: {
    /**
     * 页面跳转
     */
    goView(path, params) {
      this.$router.push({ path, query: params });
    },
    getLessonPraiseInfo({ lessonId, teacherId }) {
      let params = {
        lesson_id: lessonId,
        teacher_id: teacherId,
      }
      leaveamessageinquireall(params).then(res => {
        let result = res.data.information;
        let info = result.Informationcourse;
        let infoStore = {
          timeWeek: `${new Date(Number(info.signintime + '000')).getFullYear()}年${addZoo(new Date(Number(info.signintime + '000')).getMonth() + 1)}月${addZoo(new Date(Number(info.signintime + '000')).getDate())}日  ${this.weekSelect[new Date(Number(info.signintime + '000')).getDay() - 1]}`,
          timeStart: info.start_time,
          timeEnd: info.stop_time,
          timeDiff: (Number(this.num(info.stop_time, ':')) - Number(this.num(info.start_time, ':'))) + '课时',
          grade: info.lesson,
          one: result.one,
          zero: result.zero,
          state: true,
          lessonId: info.lesson_id,
          teacherId: info.teacher_id,
        }

        let studentStor = [[], []];
        if (result.listaone.length) {
          studentStor[0] = result.listaone;
        }
        if (result.listazero.length) {
          studentStor[1] = result.listazero;
        }
        this.info = infoStore;
        this.student = studentStor;
        if (!studentStor[1].length) {
          this.currIndex = 0;
        }
      })
    },
    num(str, find) {
      let index = str.indexOf(find);
      if (index) {
        return str.slice(0, index);
      }
    },
  },
  mounted() {
    this.getLessonPraiseInfo(this.$route.query);
  }
}
</script>

<style scoped>
.comment-praise-info {
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.grade-info {
  padding: 0.2rem 0.4rem 0.3rem;
}

.time-week,
.grade-name {
  font-size: 19PX;
  color: rgb(7, 7, 7);
}

.time-start-end {
  display: flex;
  /* padding: 0 0.1rem; */
}

.boundary {
  width: 14px;
  margin: 0 0.2rem;
  display: flex;
  align-items: center;
}

.boundary-line {
  width: 100%;
  height: 0.02rem;
  background-color: #a9a4a4;
  border-radius: 100%;
}

.time-start,
.time-end {
  font-size: 19px;
}

.time-diff {
  display: flex;
  align-items: center;
  color: darkgray;
  font-size: 0.32rem;
  margin-left: 0.2rem;
  border: 0.02rem solid #cecece;
  padding: 0.06rem 0.1rem;
  border-radius: 0.06rem;
}

.comment-conent {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.select-box {
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 0.02rem solid #f3f3f3;
  font-size: 0.34rem;
}

.hidde {
  display: none;
}

.select-btn {
  padding: 0.14rem 0;
  margin: 0 10%
}

.activeLine {
  color: #2980f7;
  border-bottom: 0.02rem solid #f48b16e8;
}

.comment-list-box {
  flex: 1;
  overflow-y: scroll;
}

.student-item {
  padding: 0.3rem;
  display: flex;
  border-top: 0.02rem solid #f3f3f3;
  align-items: center;
}

.student-img {
  width: 1.2rem;
  height: 1.2rem;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 0.3rem;
}

.student-img img {
  width: 100%;
  height: 100%;
}

.student-name {
  display: flex;
  flex: 1;
  align-items: center;
}

.arrive {
  font-size: 0.26rem;
  display: flex;
  align-items: center;
  margin-left: 0.2rem;
  border: 1px solid #f48b16e8;
  color: #f48b16e8;
  height: 0.36rem;
  padding: 0 0.1rem;
  border-radius: 0.04rem;
}

.go-commenting {
  font-size: 0.34rem;
  color: #2980f7;
}

.foot-text {
  text-align: center;
  padding: 0.4rem 0;
}
</style>